import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

const MetricsPanel = ({ workflow }) => {
  if (!workflow) return null;

  const totalDetected = workflow.detected.reduce((sum, w) => sum + w.frequency, 0);
  const avgConfidence = workflow.detected.reduce((sum, w) => sum + w.confidence, 0) / workflow.detected.length;
  const systems = new Set();
  workflow.detected.forEach(w => {
    w.detectedFrom.forEach(s => systems.add(s.system));
  });

  return (
    <Card className="mb-1 shadow-sm">
      <Card.Header className="bg-primary text-white py-1 px-2">
        <h5 className="mb-0" style={{fontSize: '1rem'}}>Workflow Metrics</h5>
      </Card.Header>
      <Card.Body className="py-1 px-2">
        <Row>
          <Col md={3}>
            <div className="metric-item">
              <div className="metric-value text-primary">{totalDetected}</div>
              <div className="metric-label">Total Detected Instances</div>
            </div>
          </Col>
          <Col md={3}>
            <div className="metric-item">
              <div className="metric-value text-success">{workflow.detected.length}</div>
              <div className="metric-label">Unique Variants</div>
            </div>
          </Col>
          <Col md={3}>
            <div className="metric-item">
              <div className="metric-value text-warning">{Math.round(avgConfidence * 100)}%</div>
              <div className="metric-label">Avg. Confidence</div>
            </div>
          </Col>
          <Col md={3}>
            <div className="metric-item">
              <div className="metric-value text-info">{systems.size}</div>
              <div className="metric-label">Data Sources</div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MetricsPanel;

